import Marquee from "react-fast-marquee";
import { MaskText, Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    t: "Clinical results, a gentler philosophy.",
    b: "The same proven actives skin experts reach for — tretinoin, hydroquinone, azelaic acid — offered honestly and priced kindly. Real results, none of the theatre.",
  },
  {
    n: "02",
    t: "Made for every shade of skin.",
    b: "Pigment behaves differently across tones. Our fade protocols are formulated — and photographed — with deeper skin at the center, never the afterthought.",
  },
  {
    n: "03",
    t: "Balance, not pressure.",
    b: "Take what you need, when you need it. Skin is one-and-done, and weight support is a flat monthly price you can pause or cancel anytime. No traps.",
  },
  {
    n: "04",
    t: "Transparent by nature.",
    b: "Clear pricing, clear ingredients, a certificate of analysis on request. We tell you exactly what you're getting — and exactly what you're not.",
  },
];

export default function Manifesto() {
  return (
    <section className="relative bg-[var(--ink)] text-[var(--bone)] py-24 sm:py-40 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="flex items-start justify-between mb-16 sm:mb-24">
          <MaskText
            as="h2"
            lines={["Why", "Balance"]}
            className="font-display text-6xl sm:text-8xl lg:text-[9vw] leading-[0.85] tracking-tighter"
          />
          <Reveal delay={0.2}>
            <p className="overline text-[var(--sage)] max-w-[10rem] text-right leading-relaxed hidden sm:block">
              Our promise, in four parts
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-white/10 border border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.08}
              className={`bg-[var(--ink)] p-8 sm:p-12 ${
                i % 2 === 0 ? "md:col-span-7" : "md:col-span-5"
              }`}
            >
              <div className="flex flex-col h-full">
                <span className="font-mono text-[var(--terra-soft)] text-sm mb-8">
                  {c.n}
                </span>
                <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.02] tracking-tight mb-5">
                  {c.t}
                </h3>
                <p className="font-body text-white/60 leading-relaxed max-w-md mt-auto">
                  {c.b}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-20 sm:mt-28 border-y border-white/10 py-6">
        <Marquee speed={38} gradient={false} autoFill>
          {[
            "Tretinoin",
            "Hydroquinone",
            "Azelaic Acid",
            "Semaglutide",
            "Tirzepatide",
            "Flat monthly",
            "Free shipping",
            "Every shade",
          ].map((w) => (
            <span key={w} className="mq-item text-4xl sm:text-6xl px-8 text-[var(--bone)]">
              {w}
              <span className="text-[var(--terra)] px-8">✦</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
